module.exports = __webpack_public_path__ + "static/media/DMAGIC-logoold.643d3953.png";